<template>
  <span class="tag">
    {{ tagText }}
    <a @mousedown.prevent="deselect">
      <svg viewBox="0 0 24 24">
        <path d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z" />
        <path d="M0 0h24v24H0z" fill="none" />
      </svg>
    </a>
  </span>
</template>

<script>
export default {
  name: 'a-select-tags',
  props: {
    tagText: {
      type: String,
      required: true
    }
  },
  methods: {
    deselect () {
      this.$emit('deselect')
    }
  }
}
</script>

<style scoped>
.tag {
  display: inline-flex;
  align-items: center;
  background-color: #428bca;
  border-radius: 10px;
  color: #fff;
  font-size: 11px;
  padding: 0 8px;
  margin-top: 8px;
  margin-right: 8px;
  line-height: 19px;
}
.tag * {
  white-space: nowrap;
}
.tag a {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
}
.tag svg {
  fill: #fff;
  margin-bottom: 0px;
  margin-left: 2px;
  width: 14px;
  height: 14px;
}
</style>
